var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1544 16.2469L12.7244 19.6769V8.29688C14.2544 7.95687 15.3944 6.59688 15.3944 4.96688C15.3944 3.07688 13.8644 1.54688 11.9744 1.54688C10.0844 1.54688 8.55438 3.07688 8.55438 4.96688C8.55438 6.59688 9.70438 7.95687 11.2244 8.29688V19.6669L7.80438 16.2469L6.74438 17.3069L11.9744 22.5369L17.2144 17.2969L16.1544 16.2369V16.2469ZM10.0544 4.96688C10.0544 3.90688 10.9144 3.04688 11.9744 3.04688C13.0344 3.04688 13.8944 3.90688 13.8944 4.96688C13.8944 6.02688 13.0344 6.88688 11.9744 6.88688C10.9144 6.88688 10.0544 6.02688 10.0544 4.96688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnchor);
export default __webpack_public_path__ + "static/media/ic-anchor.f827ed388224a845645fdf6893da6f3e.svg";
export { ForwardRef as ReactComponent };